/**
 * Created by hgun0888
 * */

/**
 * Action Types
 */

export const REQUEST_ALL_VENDORS = 'REQUEST_ALL_VENDORS';
export const RECEIVE_ALL_VENDORS = 'RECEIVE_ALL_VENDORS';
export const REQUEST_VENDORS_BY_ITEM = 'REQUEST_VENDORS_BY_ITEM';
export const RECEIVE_VENDORS_BY_ITEM = 'RECEIVE_VENDORS_BY_ITEM';
export const REQUEST_VENDOR_BASES = 'REQUEST_VENDOR_BASES';
export const RECEIVE_VENDOR_BASES = 'RECEIVE_VENDOR_BASES';
export const RECEIVE_ERROR = 'RECEIVE_ERROR';

export const SELECT_SUVC_ASSOCIATION = 'SELECT_SUVC_ASSOCIATION';
export const SEARCH_VENDORS = 'SEARCH_VENDORS';
export const SELECT_VENDOR_ASSOCIATION = 'SELECT_VENDOR_ASSOCIATION';
export const RESET_SELECTED_SUVCS = 'RESET_SELECTED_SUVCS';
export const REQUEST_ALL_OPCOS = 'REQUEST_ALL_OPCOS';
export const RECEIVE_ALL_OPCOS = 'RECEIVE_ALL_OPCOS';
export const RECEIVE_OPCO_FETCH_ERROR = 'RECEIVE_OPCO_FETCH_ERROR';
export const ASSIGN_SELECTED_VENDORS = 'ASSIGN_SELECTED_VENDORS';
export const REQUEST_WAREHOUSES = 'REQUEST_WAREHOUSES';
export const RECEIVE_WAREHOUSES = 'RECEIVE_WAREHOUSES';
export const RECEIVE_WAREHOUSES_FETCH_ERROR = 'RECEIVE_WAREHOUSES_FETCH_ERROR';
export const SYNC_SELECTED_VENDOR_IN_FILTER = 'SYNC_SELECTED_VENDOR_IN_FILTER';

export const syncSelectedVendorInFilter = (vendorCode) => ({
  type: SYNC_SELECTED_VENDOR_IN_FILTER,
  data: { vendorCode },
});

export const requestAllVendors = () => (
  {
    type: REQUEST_ALL_VENDORS,
  });
export const requestVendorsByItem = (itemId) => ({
  type: REQUEST_VENDORS_BY_ITEM,
  data: { itemId },
});

export const receiveVendorsByItem = (data) => ({
  type: RECEIVE_VENDORS_BY_ITEM,
  data,
});
export const requestVendorBases = () => (
  {
    type: REQUEST_VENDOR_BASES,
  });
export const receiveVendorLoadError = () => (
  {
    type: RECEIVE_ERROR,
  });
export const receiveAllVendors = (data) => (
  {
    type: RECEIVE_ALL_VENDORS,
    data
  });
export const receiveVendorBases = (data) => (
  {
    type: RECEIVE_VENDOR_BASES,
    data
  });
export const selectSuvcAssociation = (row, value) => ({
  type: SELECT_SUVC_ASSOCIATION,
  data: {
    row, value
  }
});

export const searchVendors = (value, suvcMappingList) => ({
  type: SEARCH_VENDORS,
  data: {
    value, suvcMappingList
  }
});

export const selectVendorAssociation = (row, value) => ({
  type: SELECT_VENDOR_ASSOCIATION,
  data: {
    row, value
  }
});

export const resetSelectedSuvcs = () => (
  {
    type: RESET_SELECTED_SUVCS
  });

export const requestAllOpcos = () => (
  {
    type: REQUEST_ALL_OPCOS,
  });

export const receiveAllOpcos = (data) => (
  {
    type: RECEIVE_ALL_OPCOS,
    data
  });

export const assignSelectedVendors = (data) => (
  {
    type: ASSIGN_SELECTED_VENDORS,
    data
  });

export const requestWarehouses = (data) => (
  {
    type: REQUEST_WAREHOUSES,
    data
  });

export const receiveWarehouses = (data) => (
  {
    type: RECEIVE_WAREHOUSES,
    data
  });
